import { Component, OnInit, ViewChild, Inject } from '@angular/core';
import { AppConfig } from 'src/app/shared/app.config';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { GenericService } from 'src/app/generic.service';
import { HttpClient, HttpHeaders, HttpRequest, HttpEventType, HttpResponse } from '@angular/common/http';
import { FileValidator } from 'ngx-material-file-input';
import { GfileUploadVm, ScreenSize, TempUploadVm, XType } from 'src/app/models';
import { SharedAnimations } from 'src/app/shared/animations';

@Component({
  selector: 'app-out-upload-dialog',
  templateUrl: './out-upload-dialog.component.html',
  styles: [
  ],
  animations: [SharedAnimations]
})
export class OutUploadDialogComponent implements OnInit {
  @ViewChild('file')
  hasFile = false;
  fileSelectMsg = 'No file selected yet.';
  progress: number;
  message: string;
  size = new ScreenSize();
  tokenPayload: any;
  disabled = false;
  uloading = false;
  isFileUploaded = false;
  item: any;
  apiUrl = AppConfig.settings.ApiUrl;
  iForm: FormGroup;
  readonly maxSize = 104857600;
  type: string;

  typeId: number;
  selectedIdTypeId: number = 0;
  selectedIdType: string;
  clientIdTypeList: XType[];
  masterclientIdTypeList: XType[];

  selectedFiles: File[] = [];
  fileInfos: TempUploadVm[] = [];
  lastCount: number = 0;
  upModel = new GfileUploadVm();

  file: File;

  fileInput!: HTMLInputElement;
  filePreviewUrl: string | ArrayBuffer | null = null;
  isImageSelected = false;
  isPdfSelected = false;
  isFileSelected = false;

  fileInput2!: HTMLInputElement;
  filePreviewUrl2: string | ArrayBuffer | null = null;
  isImageSelected2 = false;
  isPdfSelected2 = false;
  isFileSelected2 = false;

  constructor(public dialogRef: MatDialogRef<OutUploadDialogComponent>, @Inject(MAT_DIALOG_DATA) public ddata: any, private service: GenericService, private http: HttpClient, private formBuilder: FormBuilder) {
    this.type = ddata.type;
    this.size = this.service.size;
    this.typeId = ddata.typeId;
    console.log(ddata);
  }

  get f(): any { return this.iForm.controls; }

  ngOnInit(): void {
    this.getClientIdTypeList();

    if (this.type === 'id0') {
      this.selectedIdType = 'Selfie With Photo ID';
      this.selectedIdTypeId = 29;
    }

    if (this.type === 'reg') {
      this.selectedIdType = 'Registration ID';
      this.selectedIdTypeId = 30;
    }

    if (this.type !== 'other') {
      this.loadLicenceForm();
    }
  }

  loadLicenceForm() {
    this.iForm = this.formBuilder.group({
      file: [null, [Validators.required, FileValidator.maxContentSize(this.maxSize)]],
      file2: [null, [FileValidator.maxContentSize(this.maxSize)]],
    });
  }

  getClientIdTypeList(): void {
    this.service.getData('generic/GetXTypeList/' + 'XClientIdType').then(response => {
      this.masterclientIdTypeList = response;
      this.prepareDropDownList();
    });
  }

  prepareDropDownList() {
    this.clientIdTypeList = this.masterclientIdTypeList;
    if (this.type === 'id1') {
      const filteredList = this.clientIdTypeList.filter((item: any) => item.code === '1' && item.id !== this.typeId);
      this.clientIdTypeList = filteredList;
    } else {
      const filteredList = this.clientIdTypeList.filter((item: any) => (item.code === '1' || item.code === '2') && item.id !== this.typeId);
      this.clientIdTypeList = filteredList;
    }
  }

  onChangeIdType(ev) {
    const target = ev.source.selected._element.nativeElement;
    this.selectedIdTypeId = ev.value;
    this.selectedIdType = target.innerText.trim();
    console.log(this.selectedIdTypeId + ' -- ' + this.selectedIdType);
  }

  getSubmitBtnVisible(): boolean {
    if (this.selectedIdTypeId === 1) {
      if (this.isFileSelected && this.isFileSelected2) {
        return true;
      } else {
        return false;
      }
    } else {
      if (this.isFileSelected) {
        return true;
      } else {
        return false;
      }
    }
  }

  // onFileChange(ev): void {
  //   this.hasFile = true;
  //   this.file = ev.target.files[0] as File;
  // }

  onFileSelected(event: Event) {
    const vfile = (event.target as HTMLInputElement).files?.[0];
    this.fileInput = event.target as HTMLInputElement;
    if (vfile) {
      const reader = new FileReader();
      reader.onload = () => {
        this.filePreviewUrl = reader.result;
        this.isImageSelected = vfile.type.startsWith('image/');
        this.isPdfSelected = vfile.type === 'application/pdf';
        this.isFileSelected = this.isImageSelected || this.isPdfSelected;
      };
      reader.readAsDataURL(vfile);
    }
  }

  clearFile() {
    //this.hasFile = false;
    this.filePreviewUrl = null;
    this.isImageSelected = false;
    this.isPdfSelected = false;
    this.isFileSelected = false;
    if (this.fileInput) {
      this.fileInput.value = '';
    }
    this.resetFileInput();
  }

  onFileSelected2(event: Event) {
    const vfile2 = (event.target as HTMLInputElement).files?.[0];
    this.fileInput2 = event.target as HTMLInputElement;
    if (vfile2) {
      const reader2 = new FileReader();
      reader2.onload = () => {
        this.filePreviewUrl2 = reader2.result;
        this.isImageSelected2 = vfile2.type.startsWith('image/');
        this.isPdfSelected2 = vfile2.type === 'application/pdf';
        this.isFileSelected2 = this.isImageSelected2 || this.isPdfSelected2;
      };
      reader2.readAsDataURL(vfile2);
    }
  }

  clearFile2() {
    //this.hasFile = false;
    this.filePreviewUrl2 = null;
    this.isImageSelected2 = false;
    this.isPdfSelected2 = false;
    this.isFileSelected2 = false;
    if (this.fileInput2) {
      this.fileInput2.value = '';
    }
    this.resetFileInput2();
  }


  resetFileInput() {
    this.iForm.patchValue({ file: null });
    const fileInput = document.querySelector('input[type="file"]') as HTMLInputElement;
    if (fileInput) {
      fileInput.value = '';
    }
  }

  resetFileInput2() {
    this.iForm.patchValue({ file2: null });
    const fileInput2 = document.querySelector('input[type="file2"]') as HTMLInputElement;
    if (fileInput2) {
      fileInput2.value = '';
    }
  }

  // onSubmitDriverLicence(): void {

  // }

  onSubmit(): void {
    console.log(1);

    const file = this.fileInput?.files?.length ? this.fileInput.files[0] : null;
    const file2 = this.fileInput2?.files?.length ? this.fileInput2.files[0] : null;

    console.log(2);

    if (this.selectedIdTypeId === 1) {
      if (file) { } else { this.service.error('Please upload front side of Driver Licence!'); return; }
      if (file2) { } else { this.service.error('Please upload back side of Driver Licence!'); return; }
    }
    else {
      if (file) { } else { this.service.error('Please upload file!'); return; }
    }

    if (file) {
      this.uloading = true;
      const formData = new FormData();
      formData.append(file.name, file);

      if (this.type === 'id1' || this.type === 'id2' || this.type === 'id0') {
        if (this.selectedIdTypeId === 1) {
          formData.append(file2.name, file2);
          formData.append('IsLicence', 'yes');
          formData.append('Uid', this.ddata.uid + '');
          formData.append('FormName', this.ddata.formname);
          formData.append('IdTypeId', this.selectedIdTypeId + '');
          formData.append('IdType', this.selectedIdType);
        } else {
          formData.append('Uid', this.ddata.uid + '');
          formData.append('FormName', this.ddata.formname);
          formData.append('IsLicence', 'no');
          formData.append('IdTypeId', this.selectedIdTypeId + '');
          formData.append('IdType', this.selectedIdType);
        }
      }
      else if (this.type === 'reg') {
        if (this.ddata.isClient) {
          formData.append('IsClient', 'yes');
        } else {
          formData.append('IsClient', 'no');
        }
        formData.append('Uid', this.ddata.uid + '');
        formData.append('FormName', this.ddata.formname);
      }
      else if (this.type === 'Licence') {
        formData.append(file2.name, file2);
        formData.append('IsLicence', 'yes');
        formData.append('Uid', this.ddata.uid + '');
        formData.append('FormName', this.ddata.formname);
      }
      else if (this.type === 'Photo ID' || this.type === 'Non Photo ID' || this.type === 'Non Photo ID 2') {
        formData.append('Uid', this.ddata.uid + '');
        formData.append('FormName', this.ddata.formname);
        formData.append('IsLicence', 'no');
      } else {
        formData.append('ClientId', this.ddata.clientId + '');
        formData.append('InvoiceId', this.ddata.invoiceId + '');
        formData.append('IsLicence', 'no');
      }

      console.log('Id -- ' + this.ddata.uid + ' -- ' + this.ddata.isClient);

      const headers = new HttpHeaders();
      headers.append('Content-Type', 'application/json');
      headers.append('Authorization', `Bearer ${this.service.getToken()}`);

      let uploadReq = new HttpRequest('POST', this.apiUrl + 'Authority/UploadIdProofGfile/', formData, { headers: headers, reportProgress: true });

      if (this.type === 'other') {
        uploadReq = new HttpRequest('POST', this.apiUrl + 'Authority/UploadOtherDoc/', formData, { headers: headers, reportProgress: true });
      }

      if (this.type === 'reg') {
        uploadReq = new HttpRequest('POST', this.apiUrl + 'Authority/UploadRegistrationId/', formData, { headers: headers, reportProgress: true });
      }

      this.http.request(uploadReq).subscribe(event => {
        if (event.type === HttpEventType.UploadProgress) {
          this.progress = Math.round((100 * event.loaded) / event.total);
        } else if (event.type === HttpEventType.Response) {
          const res = event.body as any;
          if (res.success === true) {
            this.uloading = false;
            this.service.success('File uploaded successfully!');
            this.isFileUploaded = true;
          } else {
            this.uloading = false;
            this.service.error(res.error);
          }
        }
      });
    } else {
      this.service.error('Please select file');
    }
  }

  cancelEvent(): void {
    this.fileSelectMsg = 'No file selected yet.';
    this.hasFile = false;
    this.file = null;
  }

  close(): void {
    this.dialogRef.close(this.isFileUploaded);
  }

  // =======================================================================
  // Step 1 of 6 - File Upload
  selectMultipleFiles(event): void {
    for (let i = 0; i < event.target.files.length; i++) {
      this.selectedFiles.push(event.target.files[i] as File);
    }
    this.service.olog(this.selectedFiles);

    if (this.lastCount === 0) {
      this.processFiles(this.lastCount);
    }
    else {
      this.processFiles(this.lastCount);
    }

  }

  // Step 2 of 6 - File Upload
  processFiles(start) {
    for (let i = start; i < this.selectedFiles.length; i++) {
      var file = this.selectedFiles[i];
      const item = this.service.prepareTempUploadVm(file, i);
      this.upload(item, file);
      this.lastCount = i + 1;
    }
  }

  // Step 3 of 6 - File Upload
  upload(item: TempUploadVm, file: File): void {
    this.fileInfos.push(item);
    const formData = this.getFormData();
    formData.append(file.name, file);


    const headers = new HttpHeaders();
    headers.append('Content-Type', 'application/json');
    headers.append('Authorization', `Bearer ${this.service.getToken()}`);
    let uploadReq = new HttpRequest('POST', this.apiUrl + 'Authority/UploadOtherDoc/', formData, { headers: headers, reportProgress: true });

    var progressIndex = this.fileInfos.map(function (item) { return item.idx; }).indexOf(item.idx);
    this.http.request(uploadReq).subscribe(event => {
      if (event.type === HttpEventType.UploadProgress) {
        this.fileInfos[progressIndex].progress = Math.round(100 * event.loaded / event.total);
      } else if (event instanceof HttpResponse) {
        const res = event.body as any;
        if (res.success === true) {
          this.service.success('Files has been uploaded successfully!');
        } else {
          // this.selectedFiles = this.service.arrayRemove(this.selectedFiles, file);
          // this.fileInfos = this.service.arrayRemove(this.fileInfos, item);
          item.progress = 100;
          item.hasError = true;
          // this.service.olog(this.selectedFiles);
          this.service.error(res.error);
        }
      }
    },
      err => {
        this.fileInfos[progressIndex].progress = 0;
        // this.message = 'Could not upload the file:' + file.name;
      });
  }

  getFormData(): FormData {
    let formData = new FormData();
    formData.append('ClientId', this.ddata.clientId + '');
    formData.append('InvoiceId', this.ddata.invoiceId + '');
    return formData;
  }


}
